/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino } from './SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino';
import {
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAinoFromJSON,
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAinoFromJSONTyped,
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAinoToJSON,
} from './SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino';
import type { SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant } from './SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant';
import {
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantFromJSON,
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantFromJSONTyped,
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantToJSON,
} from './SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant';
import type { SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi } from './SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi';
import {
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiFromJSON,
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiFromJSONTyped,
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiToJSON,
} from './SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi';
import type { SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant } from './SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant';
import {
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistantFromJSON,
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistantFromJSONTyped,
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistantToJSON,
} from './SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant';
import type { SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoe } from './SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoe';
import {
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoeFromJSON,
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoeFromJSONTyped,
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoeToJSON,
} from './SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoe';
import type { SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch } from './SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch';
import {
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitchFromJSON,
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitchFromJSONTyped,
  SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitchToJSON,
} from './SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch';

/**
 * @type SingleTurnChatInferencerPolymorphic
 *
 * @export
 */
export type SingleTurnChatInferencerPolymorphic =
  | ({ protocol: 'AINO' } & SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino)
  | ({
      protocol: 'AZURE_OPEN_AI_ASSISTANT';
    } & SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant)
  | ({ protocol: 'CUSTOM_API' } & SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi)
  | ({ protocol: 'OPEN_AI_ASSISTANT' } & SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant)
  | ({ protocol: 'POE' } & SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoe)
  | ({ protocol: 'SPITCH' } & SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch);

export function SingleTurnChatInferencerPolymorphicFromJSON(json: any): SingleTurnChatInferencerPolymorphic {
  return SingleTurnChatInferencerPolymorphicFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerPolymorphicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerPolymorphic {
  if (json == null) {
    return json;
  }
  switch (json['protocol']) {
    case 'AINO':
      return Object.assign(
        {},
        SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAinoFromJSONTyped(json, true),
        { protocol: 'AINO' } as const,
      );
    case 'AZURE_OPEN_AI_ASSISTANT':
      return Object.assign(
        {},
        SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantFromJSONTyped(json, true),
        { protocol: 'AZURE_OPEN_AI_ASSISTANT' } as const,
      );
    case 'CUSTOM_API':
      return Object.assign(
        {},
        SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiFromJSONTyped(json, true),
        { protocol: 'CUSTOM_API' } as const,
      );
    case 'OPEN_AI_ASSISTANT':
      return Object.assign(
        {},
        SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistantFromJSONTyped(json, true),
        { protocol: 'OPEN_AI_ASSISTANT' } as const,
      );
    case 'POE':
      return Object.assign(
        {},
        SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoeFromJSONTyped(json, true),
        { protocol: 'POE' } as const,
      );
    case 'SPITCH':
      return Object.assign(
        {},
        SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitchFromJSONTyped(json, true),
        { protocol: 'SPITCH' } as const,
      );
    default:
      throw new Error(`No variant of SingleTurnChatInferencerPolymorphic exists with 'protocol=${json['protocol']}'`);
  }
}

export function SingleTurnChatInferencerPolymorphicToJSON(value?: SingleTurnChatInferencerPolymorphic | null): any {
  if (value == null) {
    return value;
  }
  switch (value['protocol']) {
    case 'AINO':
      return SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAinoToJSON(value);
    case 'AZURE_OPEN_AI_ASSISTANT':
      return SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantToJSON(value);
    case 'CUSTOM_API':
      return SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiToJSON(value);
    case 'OPEN_AI_ASSISTANT':
      return SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistantToJSON(value);
    case 'POE':
      return SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoeToJSON(value);
    case 'SPITCH':
      return SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitchToJSON(value);
    default:
      throw new Error(`No variant of SingleTurnChatInferencerPolymorphic exists with 'protocol=${value['protocol']}'`);
  }
}
